import Vue from "vue"
import Buefy from "buefy"
import ContactInbox from "./App.vue"

Vue.use(Buefy, {
    defaultIconPack: 'fas',
})

Vue.use(ContactInbox)

if(document.getElementById("contactInboxApp")){
    new Vue({
        render:h=>h(
            ContactInbox,{
                props:{
                    listUrl:document.getElementById("contactInboxApp")
                        .getAttribute("list-url")
                }
            }
        )
    }).$mount("#contactInboxApp")
}